<template>
  <em class="optionalLabel">任意</em>
</template>

<script lang="ts">
export default {
  name: 'LabelOptional'
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.optionalLabel {
  display: inline-block;
  width: 50px;
  height: 20px;
  font-style: normal;
  background-color: var.$color-gray;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-weight: 900;
  font-size: 1rem;
}
</style>
